<template>
    <section>
        <div class="grid fixed fixed-max-sm sm-grid-cols-2 gap-3">
            <div class="wrap text-center">
                <h2 class="f3 text-bold"> Partner with a top-rated {{ glb.geo.city }} agent that you can trust</h2>
            </div>
            <div class="grid xs-grid-cols-1">
                <div>
                    When the time's right, we'll carefully match you with a highly-qualified, top local Real Estate agent, who will adapt their expertise and knowledge to your specific circumstance and help guide you through each step of your real estate journey.
                </div>
                <ul class="grid xs-grid-cols-2 sm-grid-cols-3 f7 text-center">
                    <li>
                        <i class="icon-hand-care f3"></i>
                        <p>Carefully Vetted </p>
                        <p>Professionals</p>
                    </li>
                    <li>
                        <i class="icon-statistics-report f3"></i>
                        <p>Experienced</p>
                        <p>Negotiators</p>
                    </li>
                    <li>
                        <i class="icon-user-check f3"></i>
                        <p>Local Market</p>
                        <p>Real Estate Experts</p>
                    </li>
                    <li>
                        <i class="icon-shield-star f3"></i>
                        <p>25,000+</p>
                        <p>Experienced Agents</p>
                    </li>
                    <li>
                        <i class="icon-doc f3"></i>
                        <p>3+ Years in</p>
                        <p>the Industry</p>
                    </li>
                    <li>
                        <i class="icon-map-pin-home f3"></i>
                        <p>Nationwide</p>
                        <p>Representation</p>
                    </li>
                </ul>
            </div>
            <div class="grid xs-grid-cols-1 agent-words">
                <div>
                    <img class="circle large float-left m-r-2" loading="lazy" :src="glb.cdnUrl + 'vimages/agents/mahailey.jpg'" alt="Mahailey R.">
                    <div>
                        <div>From the first time we spoke to him, we knew our agent was very knowledgeable in the areas we were interested in, and we truly had trust in him really quickly.</div>
                        <div class="text-right"> - Mahailey R.</div>
                    </div>
                </div>
                <div>
                    <img class="circle large float-left m-r-2"  loading="lazy" :src="glb.cdnUrl + 'vimages/agents/william.jpg'" alt="William H.">
                    <div>
                        <div>As a first-time homebuyer, there are a lot of unknowns and a lot of questions. Our top local Real Estate agent anticipated questions and would help us navigate negotiations. He was always available for a call and always very communicative and accessible.</div>
                        <div class="text-right"> - William H.</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script src="./agent-tips.js"></script>
